import { useSelector } from 'react-redux';
import { crossIcon } from '../../../Assets/svg'
import AddToPlaylist from './AddToPlaylist'
import { useEffect } from 'react';
import { getPlaylistType, hasSingleType } from '../../../Util/helpers';
import { useTranslation } from 'react-i18next';

const AddToPlaylistTray = ({ isOpen, onClose }) => {
    const { t } = useTranslation();
    const { playingTracks, config } = useSelector((state) => state.player);
    const size = hasSingleType(playingTracks);
    const playlist_type = config.type === "playlist" ? config.playlist_type : size ? getPlaylistType(playingTracks[0]) : "all"

    const playlist_config = {
        id: null,
        name: '',
        data: playingTracks,
        shouldValidate: true,
        playlist_type: playlist_type
    };

    return (
        <div className={`d-flex flex-column mixerTray playist-tray ${isOpen ? 'open' : 'close'}`}>
            <div className="mixerHeader flex-shrink-0 p-3 py-4">
                <h3>{t("playlists.addToPlaylist")}</h3>
                <div className="text-end d-flex align-items-center gap-2">
                    <button className="notButton d-flex align-items-center ms-1" onClick={onClose} >
                        <img src={crossIcon} alt="Close Button" />
                    </button>
                </div>
            </div>
            <div className='flex-grow-1 d-flex flex-column pt-2'>
                {isOpen && <AddToPlaylist config_list={playlist_config} />}
            </div>
        </div>
    )
}

export default AddToPlaylistTray
